import ChannelsV2Empty from './ChannelsV2Empty'
export default ChannelsV2Empty
